import { useMutation } from '@tanstack/react-query';

import * as folderServices from 'services/folder';
import { dialogFunctionAsync, CustomNotification } from 'common/components';

import { getManageScheduleDownloadKey } from './queries';

export const useDeleteScheduleDownload = (props) => {
  const { folderId } = props;

  const deleteScheduleDownload = useMutation({
    mutationKey: ['delete-schedule-download-folder'],
    mutationFn: async (params) => {
      try {
        return folderServices.removeFolderScheduleDownload(params);
      } catch (error) {
        console.error('error: ', error);
      }
    },
    meta: {
      invalidates: [getManageScheduleDownloadKey(folderId)],
    },
  });

  const showDeleteConfirm = () => {
    return dialogFunctionAsync({
      type: 'warn',
      content: 'Are you sure you want to delete schedule?',
      okText: 'Delete',
      cancelText: 'Cancel',
      okButtonProps: {
        danger: true,
      },
    });
  };

  const showDeleteMessage = (status, message) => {
    if (status === 'success') {
      CustomNotification.success('Delete Schedule successfully');
    } else {
      CustomNotification.error(message || 'Fail to delete Schedule');
    }
  };

  return { deleteScheduleDownload, showDeleteConfirm, showDeleteMessage };
};
